import { makeGet } from '../../utils/call-api-endpoint';
import type { Envelope } from '../../utils/envelope';
import type { HistoricoArete } from './aretes.dto';

export async function existeAreteSiiniga(areteSiiniga: string, folio: string): Promise<boolean> {
  const response = await makeGet<boolean>(
    `/pre-compras/existe-arete-siiniga/${areteSiiniga}?folio=${folio}`
  );
  return response.result;
}

export async function existeAreteTemporal(areteTemporal: string, folio: string): Promise<boolean> {
  const response = await makeGet<boolean>(
    `/pre-compras/existe-arete-temporal/${areteTemporal}?folio=${folio}`
  );
  return response.result;
}

export async function obtenerHistorialAreteSiiniga(
  folio: string,
  partida: number
): Promise<Envelope<HistoricoArete[]>> {
  const response = await makeGet<HistoricoArete[]>(
    `/pre-compras/${folio}/historial-arete-siiniga/${partida}`
  );
  return response;
}

export async function obtenerHistorialAreteTemporal(
  folio: string,
  partida: number
): Promise<Envelope<HistoricoArete[]>> {
  const response = await makeGet<HistoricoArete[]>(
    `/pre-compras/${folio}/historial-arete-temporal/${partida}`
  );
  return response;
}
